export default "__VITE_ASSET__7Y$XH56t__"